<template>
  <div class="footer">
    <div class="footer-container">
      <div>
        <div class="full-width-gray-line"></div>
      </div>

      <!-- Logo -->
      <div class="logo-wrapper">
        <router-link to="/">
          <img
            class="logo logo-desktop"
            src="@/assets/images/desktop/header/basic_logo_cn_l_1.png"
            alt="chatxbuy"
          />
          <img
            class="logo logo-mobile"
            src="@/assets/images/mobile/footer/basic_logo_cn_l_1.jpg"
            alt="chatxbuy"
          />
        </router-link>
      </div>

      <!-- Navigation Links - Desktop only -->
      <div class="nav-links">
        <div class="footer_herf">
          <router-link
            style="text-decoration: none; color: inherit"
            to="/page/service"
          >
            <span class="button-pointer footer_text">服務介紹</span>
          </router-link>
        </div>

        <div class="footer_span">|</div>

        <div class="footer_herf">
          <router-link
            style="text-decoration: none; color: inherit"
            to="/page/freight"
          >
            <span class="button-pointer footer_text">費用說明</span>
          </router-link>
        </div>

        <div class="footer_span">|</div>

        <div class="footer_herf">
          <router-link
            style="text-decoration: none; color: inherit"
            to="/page/faq"
          >
            <span class="button-pointer footer_text">Q&A</span>
          </router-link>
        </div>

        <div class="footer_span">|</div>

        <div class="footer_herf">
          <router-link
            style="text-decoration: none; color: inherit"
            to="/page/blogList"
          >
            <span class="button-pointer footer_text">Blog</span>
          </router-link>
        </div>

        <div class="footer_span">|</div>

        <div class="footer_herf">
          <router-link
            style="text-decoration: none; color: inherit"
            to="/page/aboutUs"
          >
            <span class="button-pointer footer_text">關於我們</span>
          </router-link>
        </div>
      </div>

      <!-- Secondary Links -->
      <div class="secondary-links">
        <div class="footer_herf">
          <router-link
            style="text-decoration: none; color: inherit"
            to="/page/prohibit"
          >
            <span class="button-pointer footer_text">禁運商品</span>
          </router-link>
        </div>

        <div class="footer_herf">
          <router-link
            style="text-decoration: none; color: inherit"
            to="/page/termsService"
          >
            <span class="button-pointer footer_text">服務條款</span>
          </router-link>
        </div>

        <div class="footer_herf">
          <router-link
            style="text-decoration: none; color: inherit"
            to="/page/privacyPolicy"
          >
            <span class="button-pointer footer_text">隱私權政策</span>
          </router-link>
        </div>
      </div>

      <!-- Bottom Blue Section -->
      <div class="footer-blue-section">
        <div class="social-icons">
          <div style="padding-right: 24px">
            <a href="https://www.facebook.com/chatXbuy/" target="_blank">
              <img
                class="social-icon-desktop"
                src="@/assets/images/desktop/header/Vector-FB.svg"
                alt="FB"
              />
              <img
                class="social-icon-mobile"
                src="@/assets/images/mobile/footer/Negative-fb.svg"
                alt="FB"
              />
            </a>
          </div>

          <div>
            <a href="https://www.instagram.com/chatxbuy/" target="_blank">
              <img
                class="social-icon-desktop"
                src="@/assets/images/desktop/header/Negative-IG.svg"
                alt="ig"
              />
              <img
                class="social-icon-mobile"
                src="@/assets/images/mobile/footer/Negative-ig.svg"
                alt="ig"
              />
            </a>
          </div>
        </div>

        <div class="footer-blue-footer">
          代買幫商行<br />
          客服時段：週一～週五 09:30~18:30<br />
          Copyright© 2024 chatxbuy All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-footer",
  data() {
    return {};
  },
  methods: {
    scrollToTop() {
      if (typeof window === "undefined") return;
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
/* Mobile-first Base Styles */
.full-width-gray-line {
  width: 100vw;
  height: 1px;
  background-color: #dee2e6;
}

.footer {
  height: 370px;
}

.footer-container {
  display: flex;
  flex-direction: column;
}

.logo-wrapper {
  margin-left: 16px;
  margin-bottom: 36px;
  margin-top: 48px;
}

.logo {
  width: 104px;
}

/* Mobile shows mobile images, hides desktop */
.logo-desktop,
.social-icon-desktop {
  display: none;
}

.logo-mobile,
.social-icon-mobile {
  display: inline-block;
}

/* Navigation Links - Hidden on mobile */
.nav-links {
  display: none;
}

/* Secondary Links - Mobile vertical layout */
.secondary-links {
  display: flex;
  flex-direction: column;
  margin-left: 16px;
}

.secondary-links .footer_herf {
  margin-bottom: 24px;
}

.footer_text {
  font-size: 14px;
  color: #3a3a3a;
}

.footer_text:hover {
  color: #0751a0;
}

/* Blue Footer Section */
.footer-blue-section {
  display: flex;
  flex-direction: column;
  background-color: #2a40b3;
  width: 100vw;
  padding-left: 16px;
}

.social-icons {
  display: flex;
  margin-top: 40px;
  margin-bottom: 24px;
}

.footer-blue-footer {
  color: #fff;
  font-size: 14px;
  line-height: 28px;
  padding-bottom: 40px;
}

/* Desktop Styles (min-width: 1060px) */
@media (min-width: 1060px) {
  .footer {
    margin: 0 auto;
  }

  .footer-container {
    align-items: center;
  }

  .logo-wrapper {
    margin-left: 0;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    margin-top: 36px;
  }

  .logo {
    width: 144px;
  }

  /* Desktop shows desktop images, hides mobile */
  .logo-desktop,
  .social-icon-desktop {
    display: inline-block;
  }

  .logo-mobile,
  .social-icon-mobile {
    display: none;
  }

  /* Show navigation links on desktop */
  .nav-links {
    display: flex;
    justify-content: center;
  }

  .footer_span {
    display: inline;
    margin-left: 20px;
    margin-right: 20px;
    color: #868e96;
  }

  .footer_text {
    font-size: clamp(14px, 1.11vw, 16px);
  }

  /* Secondary Links - Desktop horizontal layout */
  .secondary-links {
    flex-direction: row;
    margin-left: 0;
    margin-top: 28px;
    margin-bottom: 32px;
  }

  .secondary-links .footer_herf {
    margin-bottom: 0;
    margin-left: 0;
  }

  .secondary-links .footer_herf:not(:first-child) {
    margin-left: 46px;
  }

  /* Blue Footer Section - Desktop centered */
  .footer-blue-section {
    align-items: center;
    justify-content: center;
    padding-left: 0;
  }

  .social-icons {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .footer-blue-footer {
    text-align: center;
    padding-bottom: 36px;
  }
}
</style>
